/**
 * Dispatches a GTM event by pushing it to the dataLayer.
 *
 * @param {object} eventObj - The event object to be dispatched to GTM.
 * @param {boolean} clearEcommerceLayer - Empty the ecommerce layer to prevent overlapping
 */
function dispatchGtmEvent(eventObj, clearEcommerceLayer = false) {
    console.log('GTM Event', eventObj);
    if (typeof eventObj !== 'object' || eventObj === null) {
        console.error('Invalid GTM event: eventObj must be a non-null object.');
        return;
    }

    if (typeof window === 'undefined') {
        console.error('GTM dispatch attempted in a non-browser environment.');
        return;
    }

    window.dataLayer = window.dataLayer || [];
    if (clearEcommerceLayer) {
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    }
    window.dataLayer.push(eventObj);
}
;
define("skr/tracking/dispatchGtmEvent", function(){});

